module.exports = __webpack_public_path__ + "static/HyperionArcR-9d4edf951ec57f991e346d7a96eabfba.png";